export default __webpack_public_path__ + "static/media/Shiva-temple-Maheshwar-172915-pixahive.39819d96.jpg";